module.exports = __webpack_public_path__ + "img/valance-wave-scallop-short.7e85583f.svg";